/** Roles used for frontend route guards (aligned with Layout nav + API). */
export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  SALES_MANAGER: 'sales_manager',
  DESIGNER: 'designer',
  OPERATOR: 'operator',
};

export const ADMIN_MANAGER = [ROLES.ADMIN, ROLES.MANAGER];

export const SALES_AND_UP = [ROLES.ADMIN, ROLES.MANAGER, ROLES.SALES_MANAGER];

export const ALL_STAFF = [
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.SALES_MANAGER,
  ROLES.DESIGNER,
  ROLES.OPERATOR,
];
